/**
 * Update button
 *
 * @return {void}
 */
 const updateButton = () => {
  //  const form = $('.modal-content form[data-product-form]');

   if (window.CUSTOMER) {
     $('.modal-content form[data-login-button="true"] .slideshow-button').addClass('hide');
     $('.modal-content form[data-login-button="true"] .product-form--atc').removeClass('hide');
   } else {
    $('.modal-content form[data-login-button="true"] .slideshow-button').removeClass('hide');
    $('.modal-content form[data-login-button="true"] .product-form--atc').addClass('hide');
   }
};

/**
 * LoginButtonController
 *
 * @return {void}
 */
const LoginButtonController = () => {
  window.WhatSub.subscribe("LOGIN_BUTTON", updateButton);
};

export default LoginButtonController;



// WEBPACK FOOTER //
// ./src/js/modules/product/controllers/LoginButtonController.js